import type { RouteObject } from 'react-router-dom'

import { profilePathPrefixes } from './route-paths'

const flashcardsHandle = { studyMode: 'flashcards' } as const

export const storeRoutes: RouteObject[] = [
  ...['', '/studied', '/difficult'].map((suffix): RouteObject => ({
    handle: flashcardsHandle,
    path: 'store/seller/materials/:cardSetId/learn' + suffix,
    lazy: () => import('../../features/learning/ui/PersonalLearningRoute'),
  })),
  {
    path: 'store/seller/products/:productId/sets',
    lazy: () => import('../../features/store/ui/AuthorProductSetsRoute'),
  },
  {
    path: profilePathPrefixes.store.slice(1),
    lazy: () => import('../../features/store/ui/StoreCatalogRoute'),
  },
  {
    path: `${profilePathPrefixes.store.slice(1)}/products/:productId`,
    lazy: () => import('../../features/store/ui/StoreProductRoute'),
  },
  {
    path: `${profilePathPrefixes.store.slice(1)}/products/:productId/sets`,
    lazy: () => import('../../features/store/ui/ProductSetsRoute'),
  },
  ...['', '/studied', '/difficult'].map((suffix): RouteObject => ({
    handle: flashcardsHandle,
    path: `${profilePathPrefixes.store.slice(1)}/products/:productId/sets/:cardSetId/learn${suffix}`,
    lazy: () => import('../../features/learning/ui/PersonalLearningRoute'),
  })),
  {
    path: `${profilePathPrefixes.store.slice(1)}/orders/:orderId`,
    lazy: () => import('../../features/store/ui/StoreOrderRoute'),
  },
  {
    path: profilePathPrefixes.myProducts.slice(1),
    lazy: () => import('../../features/store/ui/OwnedProductsRoute'),
  },
  {
    path: profilePathPrefixes.sellerMaterials.slice(1),
    lazy: () => import('../../features/store/ui/SellerMaterialsRoute'),
  },
  {
    path: `${profilePathPrefixes.sellerMaterials.slice(1)}/:materialId/edit`,
    lazy: () => import('../../features/store/ui/ProductMaterialEditorRoute'),
  },
  {
    path: profilePathPrefixes.sellerProducts.slice(1),
    lazy: () => import('../../features/store/ui/SellerProductsRoute'),
  },
  {
    path: `${profilePathPrefixes.sellerProducts.slice(1)}/create`,
    lazy: () => import('../../features/store/ui/SellerProductEditorRoute'),
  },
  {
    path: `${profilePathPrefixes.sellerProducts.slice(1)}/:productId/preview`,
    lazy: () => import('../../features/store/ui/SellerProductPreviewRoute'),
  },
  {
    path: `${profilePathPrefixes.sellerProducts.slice(1)}/:productId/edit`,
    lazy: () => import('../../features/store/ui/SellerProductEditorRoute'),
  },
]
